<template>
  <v-container
    fluid
    grid-list-md
    text-xs-center
    style="min-height: 93.4vh"
    :key="forceUpdateKey"
  >
    <v-layout row wrap>
      <v-toolbar scroll-target="#scrolling-home" class="main-tool-bar">
        <v-layout
          py-2
          ma-0
          row
          :wrap="$vuetify.breakpoint.xsOnly"
          align-center
          justify-center
        >
          <v-flex shrink mr-auto mb-3>
            <v-toolbar-title v-show="!$vuetify.breakpoint.xsOnly">
              {{ $t('extracurricular.extracurricular_title') }}
            </v-toolbar-title>
          </v-flex>
          <v-flex xs12 sm5 lg6 grow class="titleSearch">
            <v-text-field
              v-if="userPermissions[possibleUserModulePermissions.WATCH_EXTRAS]"
              :disabled="loading"
              flat
              :label="$t('generic.search')"
              prepend-inner-icon="search"
              @click:append-outer="filterSearch"
              @click:clear="clearSearch"
              @keyup.enter="filterSearch"
              v-model="filters.search"
              clearable
              solo-inverted
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm4 lg3 shrink>
            <v-btn
              v-if="
                userPermissions[possibleUserModulePermissions.UNLINK_EXTRAS] &&
                selected.length >= 1
              "
              @click="unlinkConfirm()"
              icon
            >
              <v-icon color="red">link_off</v-icon>
            </v-btn>
            <clear-filters
              @click="removeFilters"
              v-if="showFilter"
            ></clear-filters>
          </v-flex>
        </v-layout>
        <v-speed-dial
          v-if="userPermissions[possibleUserModulePermissions.WATCH_EXTRAS]"
          key="1"
          v-model="buttonFab.fab"
          absolute
          bottom
          left
          direction="bottom"
          open-on-hover
          transition="scale-transition"
          style="bottom: 0"
        >
          <template v-slot:activator>
            <v-tooltip right>
              <template v-slot:activator="{ on }">
                <v-btn
                  style="z-index: 99"
                  color="gradiente"
                  dark
                  fab
                  v-on="on"
                  :small="$vuetify.breakpoint.xsOnly"
                >
                  <v-icon>more_vert</v-icon>
                </v-btn>
              </template>
              <span>{{ $t('generic.more_options') }}</span>
            </v-tooltip>
          </template>
          <v-tooltip right>
            <v-btn
              @click="modals.AddSL = true"
              v-if="userPermissions[possibleUserModulePermissions.LINK_EXTRAS]"
              fab
              dark
              small
              color="gradiente"
              slot="activator"
            >
              <v-icon>person_add</v-icon>
            </v-btn>
            <span>
              {{ $t('extracurricular.add_students_modal.add_students_title') }}
            </span>
          </v-tooltip>
          <v-tooltip right>
            <v-btn
              @click="modals.importSL = true"
              fab
              dark
              small
              color="gradiente"
              slot="activator"
            >
              <v-icon>note_add</v-icon>
            </v-btn>
            <span>
              {{
                $t(
                  'extracurricular.import_students_modal.import_students_modal_title'
                )
              }}
            </span>
          </v-tooltip>
          <v-tooltip right>
            <v-btn
              fab
              dark
              small
              color="gradiente"
              slot="activator"
              @click="downloadStudents"
            >
              <v-icon>file_download</v-icon>
            </v-btn>
            <span>Descargar alumnos</span>
          </v-tooltip>
          <v-tooltip right>
            <v-btn
              fab
              dark
              small
              color="gradiente"
              slot="activator"
              @click="showQrSizeModalAll"
            >
              <v-icon>qr_code</v-icon>
            </v-btn>
            <span>Descarga de QRs</span>
          </v-tooltip>
        </v-speed-dial>
      </v-toolbar>
      <v-container fluid elevation-2 class="scrollDesign table-full">
        <v-layout row wrap>
          <v-flex xs12>
            <v-data-table
              select-all
              v-model="selected"
              :headers="headers"
              :rows-per-page-items="[25, 50, 100]"
              :total-items="totalItemsFromBackend"
              :items="students"
              :loading="loading"
              :pagination.sync="pagination"
              ref="table"
              item-key="idStudentExtra"
              no-results-text="No se encontraron coincidencias"
              :no-data-text="
                userPermissions[possibleUserModulePermissions.WATCH_EXTRAS]
                  ? loading
                    ? 'Cargando'
                    : students.length > 0
                    ? ''
                    : 'No hay alumnos'
                  : 'No tienes permiso de ver alumnos'
              "
              must-sort
            >
              <template v-slot:headers="props">
                <tr>
                  <th style="width: 78px; max-width: 78px; min-width: 78px">
                    <v-checkbox
                      :input-value="props.all"
                      :indeterminate="props.indeterminate"
                      primary
                      :disabled="loading"
                      color="primary"
                      hide-details
                      @click.stop="toggleAll"
                    ></v-checkbox>
                  </th>
                  <th
                    :key="props.headers[0].text"
                    :style="props.headers[0].style"
                    :class="props.headers[0].sortable ? 'sortable_pick' : ''"
                    @click="changeSort(props.headers[0].value)"
                  >
                    {{ $t(props.headers[0].langKey) }}
                  </th>
                  <th
                    :key="props.headers[1].text"
                    :style="props.headers[1].style"
                    :class="[
                      props.headers[1].sortable ? 'sortable_pick' : '',
                      'text-xs-left',
                    ]"
                    @click="changeSort(props.headers[1].value)"
                  >
                    {{ $t(props.headers[1].langKey) }}
                    <SortTableArrow
                      :is-active="props.headers[1].value === pagination.sortBy"
                      :is-upward="pagination.descending"
                    />
                  </th>
                  <th
                    :key="props.headers[2].text"
                    :style="props.headers[2].style"
                    :class="[
                      props.headers[2].sortable ? 'sortable_pick' : '',
                      'text-xs-left',
                    ]"
                    @click="changeSort(props.headers[2].value)"
                  >
                    {{ $t(props.headers[2].langKey) }}
                    <SortTableArrow
                      :is-active="props.headers[2].value === pagination.sortBy"
                      :is-upward="pagination.descending"
                    />
                  </th>
                  <th
                    class="text-xs-left"
                    style="
                      width: 220px;
                      max-width: 220px;
                      min-width: 220px;
                      position: relative;
                    "
                  >
                    <v-select
                      multiple
                      :items="
                        userPermissions[
                          possibleUserModulePermissions.WATCH_EXTRAS
                        ]
                          ? props.headers[3].filterItems
                          : []
                      "
                      item-value="levelId"
                      item-text="levelName"
                      outline
                      height="50"
                      :disabled="loading"
                      @change="filterLevel(true)"
                      :dense="$vuetify.breakpoint.xsOnly"
                      v-model="filters.levelIds"
                      full-width
                    >
                      <template v-slot:label>
                        <span class="grey--text">
                          {{ $t(props.headers[3].langKey) }}
                        </span>
                      </template>
                      <template v-slot:selection="{ item, index }">
                        <span v-if="index === 0" class="grey--text caption"
                          >(
                          {{
                            '+' +
                            filters.levelIds.length +
                            ' filtro' +
                            (filters.levelIds.length > 1 ? 's' : '')
                          }}
                          )</span
                        >
                      </template>
                    </v-select>
                    <SortTableArrow
                      class="sort_arrow"
                      @click="changeSort(props.headers[3].value)"
                      :is-active="props.headers[3].value === pagination.sortBy"
                      :is-upward="pagination.descending"
                    />
                  </th>
                  <th
                    class="text-xs-left"
                    style="
                      width: 220px;
                      max-width: 220px;
                      min-width: 220px;
                      position: relative;
                    "
                  >
                    <v-select
                      multiple
                      :items="
                        userPermissions[
                          possibleUserModulePermissions.WATCH_EXTRAS
                        ]
                          ? props.headers[4].filterItems
                          : []
                      "
                      :disabled="loading"
                      item-value="groupId"
                      item-text="groupName"
                      height="50"
                      outline
                      v-model="filters.gradeGroupIds"
                      @change="filterGgs(true)"
                      :dense="$vuetify.breakpoint.xsOnly"
                      full-width
                    >
                      <template v-slot:label>
                        <span class="grey--text">
                          {{ $t(props.headers[4].langKey) }}
                        </span>
                      </template>
                      <template v-slot:selection="{ item, index }">
                        <span v-if="index === 0" class="grey--text caption"
                          >(
                          {{
                            '+' +
                            filters.gradeGroupIds.length +
                            ' filtro' +
                            (filters.gradeGroupIds.length > 1 ? 's' : '')
                          }}
                          )</span
                        >
                      </template>
                    </v-select>
                    <SortTableArrow
                      class="sort_arrow"
                      @click="changeSort(props.headers[4].value)"
                      :is-active="props.headers[4].value === pagination.sortBy"
                      :is-upward="pagination.descending"
                    />
                  </th>
                  <th
                    :key="props.headers[5].text"
                    :style="props.headers[5].style"
                    :class="[
                      props.headers[5].sortable ? 'sortable_pick' : '',
                      'text-xs-left',
                    ]"
                  >
                    {{ $t(props.headers[5].langKey) }}
                  </th>
                </tr>
              </template>
              <!-- <template v-slot:headers="props">
                <tr>
                  <th style="width: 78px; max-width: 78px; min-width: 78px">
                    <v-checkbox
                      :input-value="props.all"
                      :indeterminate="props.indeterminate"
                      primary
                      :disabled="loading"
                      color="primary"
                      hide-details
                      @click.stop="toggleAll"
                      v-if="permits['UNLINK_EXTRAS']"
                    ></v-checkbox>
                  </th>
                  <th
                    class="text-xs-left"
                    style="width: 70px; max-width: 70px; min-width: 70px"
                  >
                    {{ props.headers[0].text }}
                  </th>
                  <th
                    class="text-xs-left"
                    style="width: 240px; max-width: 240px; min-width: 240px"
                  >
                    {{ props.headers[1].text }}
                  </th>
                  <th
                    class="text-xs-left"
                    style="width: 240px; max-width: 240px; min-width: 240px"
                  >
                    {{ props.headers[2].text }}
                  </th>
                  <th
                    class="text-xs-left"
                    style="width: 220px; max-width: 220px; min-width: 220px"
                  >
                    <v-select
                      multiple
                      :items="
                        permits['WATCH_EXTRAS']
                          ? props.headers[3].filterItems
                          : []
                      "
                      item-value="levelId"
                      item-text="levelName"
                      outline
                      height="50"
                      :disabled="loading"
                      @change="filterLevel(true)"
                      :dense="$vuetify.breakpoint.xsOnly"
                      v-model="filters.levelIds"
                      full-width
                    >
                      <template v-slot:label>
                        <span class="grey--text">{{
                          props.headers[3].text
                        }}</span>
                      </template>
                      <template v-slot:selection="{ item, index }">
                        <span v-if="index === 0" class="grey--text caption"
                          >(
                          {{
                            '+' +
                            filters.levelIds.length +
                            ' filtro' +
                            (filters.levelIds.length > 1 ? 's' : '')
                          }}
                          )</span
                        >
                      </template>
                    </v-select>
                  </th>
                  <th
                    class="text-xs-left"
                    style="width: 220px; max-width: 220px; min-width: 220px"
                  >
                    <v-select
                      multiple
                      :items="
                        permits['WATCH_EXTRAS']
                          ? props.headers[4].filterItems
                          : []
                      "
                      :disabled="loading"
                      item-value="groupId"
                      item-text="groupName"
                      outline
                      v-model="filters.gradeGroupIds"
                      @change="filterGgs(true)"
                      :dense="$vuetify.breakpoint.xsOnly"
                      full-width
                    >
                      <template v-slot:label>
                        <span class="grey--text">Grupo</span>
                      </template>
                      <template v-slot:selection="{ item, index }">
                        <span v-if="index === 0" class="grey--text caption"
                          >(
                          {{
                            '+' +
                            filters.gradeGroupIds.length +
                            ' filtro' +
                            (filters.gradeGroupIds.length > 1 ? 's' : '')
                          }}
                          )</span
                        >
                      </template>
                    </v-select>
                  </th>
                  <th
                    class="text-xs-left"
                    style="width: 220px; max-width: 220px; min-width: 220px"
                  >
                    {{ props.headers[5].text }}
                  </th>
                </tr>
              </template> -->
              <template v-slot:items="props">
                <td
                  class="text-xs-left"
                  style="width: 78px; max-width: 78px; min-width: 78px"
                >
                  <v-checkbox
                    color="primary"
                    v-model="props.selected"
                    primary
                    hide-details
                  ></v-checkbox>
                </td>
                <td
                  class="text-xs-left"
                  style="width: 70px; max-width: 70px; min-width: 70px"
                >
                  <v-avatar
                    size="30px"
                    color="grey lighten-4"
                    v-if="
                      props.item.imageStorage &&
                      props.item.imageStorage.miniObjUrl
                    "
                  >
                    <img
                      :src="props.item.imageStorage.miniObjUrl"
                      alt="avatar"
                    />
                  </v-avatar>
                  <v-icon v-else>account_circle</v-icon>
                </td>
                <td
                  class="text-xs-left"
                  style="width: 240px; max-width: 240px; min-width: 240px"
                >
                  {{ props.item.firstName }}
                </td>
                <td
                  class="text-xs-left"
                  style="width: 240px; max-width: 240px; min-width: 240px"
                >
                  {{ props.item.lastName }}
                </td>
                <td
                  class="text-xs-left"
                  style="width: 220px; max-width: 220px; min-width: 220px"
                >
                  {{ props.item.level.typeLevel }}
                </td>
                <td
                  class="text-xs-left"
                  style="width: 220px; max-width: 220px; min-width: 220px"
                >
                  {{
                    props.item.gradeGroup.grade +
                    ' ' +
                    props.item.gradeGroup.group
                  }}
                </td>
                <td
                  class="text-xs-left"
                  style="width: 220px; max-width: 220px; min-width: 220px"
                >
                  {{ props.item.personId }}
                </td>
                <!-- <td style="width: 90px; max-width: 90px; min-width: 90px;">
                  <v-btn v-if="permits['UNLINK_EXTRAS']" @click="selectStudent(props.item)" icon>
                    <v-icon>edit</v-icon>
                  </v-btn>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        v-on="on"
                        v-if="permits['UNLINK_EXTRAS']"
                        @click="unlinkConfirm(props.item)"
                        icon
                      >
                        <v-icon color="red">link_off</v-icon>
                      </v-btn>
                    </template>
                    <span>Desvincular</span>
                  </v-tooltip>
                </td>-->
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
      </v-container>
      <linkStudentLevelModal
        v-model="modals.linkSL"
        :student="selectedA.student"
      ></linkStudentLevelModal>
      <addStudentsToExtraModal
        v-model="modals.AddSL"
        @success="resetTable"
      ></addStudentsToExtraModal>
      <importStudentsToLevelExtra
        v-model="modals.importSL"
        @success="resetTable"
      ></importStudentsToLevelExtra>
      <loading v-model="working.wUpdate" text="Trabajando..."></loading>
      <success v-model="toast.success" :text="toast.text"></success>
      <error v-model="toast.failed" :text="toast.text"></error>
      <confirm
        :class="!confirm.value ? 'position-no' : ''"
        :value="confirm.value"
        :title="confirm.title"
        :description="confirm.description"
        v-on:desition="$event ? unLinkStudentExtra() : (confirm.value = false)"
      ></confirm>
      <QRSizeModal
        @onClosed="onCancel"
        :class="!QRSizeModal.value ? 'position-no' : ''"
        v-model="QRSizeModal.value"
        :value="QRSizeModal.value"
        :title="QRSizeModal.title"
        :std="true"
        @desition="desitionSize"
        @archivoName="archivoName"
      />
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import confirm from '../../../Dialogs/Confirm'
import error from '../../../Dialogs/Error.vue'
import loading from '../../../Dialogs/Loading.vue'
import success from '../../../Dialogs/Success.vue'
import addStudentsToExtraModal from '../../../Modals/AddStudentsToExtraModal.vue'
import importStudentsToLevelExtra from '../../../Modals/ImportStudentLevelExtra'
import linkStudentLevelModal from '../../../Modals/LinkStudentLevelModal'
import QRSizeModal from '../../../Modals/QRModalStd.vue'
import ClearFilters from '../../../Tools/ClearFilters.vue'

import {
  _downloadFileFromContentDisposition,
  _genericDownloadFile,
  _getUserPermissions,
  _isSomeDifferent,
} from '../../../../utils/genericUtils.js'
import SortTableArrow from '../../../Tools/SortTableArrow.vue'

import {
  filterByGroup,
  filterByLevel,
  isEmpty,
  isNotEmpty,
  parseGroups,
  parseLevels,
} from './utils.js'

export default {
  components: {
    linkStudentLevelModal,
    addStudentsToExtraModal,
    importStudentsToLevelExtra,
    loading,
    success,
    error,
    confirm,
    ClearFilters,
    SortTableArrow,
    QRSizeModal,
  },
  props: {},
  data: () => ({
    posibleFilters: {},
    buttonFab: {
      fab: false,
    },
    totalItemsFromBackend: 0,
    students: [],
    showFilter: false,
    headers: [
      {
        text: 'Foto',
        align: 'center',
        sortable: false,
        value: 'photo',
        style: 'width: 70px; max-width: 70px; min-width: 70px',
        langKey: 'extracurricular.photo',
      },
      {
        text: 'Nombre',
        value: 'NAME',
        align: 'left',
        sortable: true,
        style: 'width: 240px; max-width: 240px; min-width: 240px',
        langKey: 'extracurricular.first_name',
      },
      {
        text: 'Apellidos',
        value: 'LAST_NAME',
        sortable: true,
        align: 'center',
        style: 'width: 240px; max-width: 240px; min-width: 240px',
        langKey: 'extracurricular.last_name',
      },

      {
        text: 'Nivel',
        value: 'LEVEL',
        sortable: true,
        filterItems: [],
        align: 'center',
        style: 'width: 240px; max-width: 240px; min-width: 240px',
        langKey: 'extracurricular.level',
      },

      {
        text: 'Grupo',
        value: 'GROUP',
        sortable: true,
        filterItems: [],
        align: 'center',
        style: 'width: 220px; max-width: 220px; min-width: 220px',
        langKey: 'extracurricular.group',
      },
      {
        text: 'Matrícula',
        value: 'personId',
        sortable: false,
        align: 'center',
        style: 'width: 220px; max-width: 220px; min-width: 220px',
        langKey: 'extracurricular.student_id',
      },
      {
        text: '',
        value: 'actions',
        sortable: false,
        align: 'center',
        style: 'width: 220px; max-width: 220px; min-width: 220px',
        langKey: '',
      },
    ],
    confirm: {
      value: false,
      title: '',
      description: '',
      show: false,
    },
    pagination: {
      descending: false,
      page: 1,
      total: 0,
      rowsPerPage: 25,
      sortBy: 'NAME',
    },
    filters: {
      // size: 25,
      // offset: 0,
      // orderBy: 'NAME',
      // orderType: 'ASC',
      search: '',
      levelIds: [],
      gradeGroupIds: [],
    },
    modals: {
      linkSL: false,
      AddSL: false,
      importSL: false,
    },
    selectedA: {
      student: {},
    },
    selected: [],
    toast: {
      success: false,
      failed: false,
      text: '',
    },
    working: {
      wUpdate: false,
    },
    loading: false,
    // permits: [],
    userPermissions: {},
    possibleUserModulePermissions: {
      WATCH_EXTRAS: 'WATCH_EXTRAS',
      UNLINK_EXTRAS: 'UNLINK_EXTRAS',
      LINK_EXTRAS: 'LINK_EXTRAS',
    },
    /**KEY TO FORCE UPDATE COMPONENTS */
    forceUpdateKey: 0,
    QRSizeModal: {
      title: '',
      value: '',
      student: [],
    },
  }),
  watch: {
    getBranch() {
      if (
        this.userPermissions[this.possibleUserModulePermissions.WATCH_EXTRAS] &&
        !this.students.length > 0
      ) {
        // this.filters.size = 25
        // this.filters.offset = 0
        // this.filters.orderBy = 'NAME'
        // this.filters.orderType = 'ASC'
        this.getStudents()
      }
    },
    getUser() {
      this.mapPermits()
      this.forceUpdateKey = Math.random()
      if (
        this.userPermissions[this.possibleUserModulePermissions.WATCH_EXTRAS] &&
        !this.students.length > 0 &&
        this.getBranch.id
      ) {
        // this.filters.size = 25
        // this.filters.offset = 0
        // this.filters.orderBy = 'NAME'
        // this.filters.orderType = 'ASC'
        this.getStudents()
      }
    },
    pagination: {
      handler() {
        //     if (
        //       this.permits['WATCH_EXTRAS'] &&
        //       this.students &&
        //       this.getBranch.id &&
        //       this.pagination.rowsPerPage &&
        //       this.pagination.page &&
        //       this.pagination.sortBy
        //     ) {
        //       this.filters.size = this.pagination.rowsPerPage
        //       this.filters.offset =
        //         (this.pagination.page - 1) * this.pagination.rowsPerPage
        //       this.filters.orderBy = this.pagination.sortBy
        //       this.filters.orderType = this.pagination.descending ? 'DESC' : 'ASC'
        this.getStudents()
        //     }
      },
      deep: true,
    },
  },
  created() {
    this.getStudents(true)
  },
  mounted() {
    this.mapPermits()
    if (
      this.getBranch.id &&
      this.userPermissions[this.possibleUserModulePermissions.WATCH_EXTRAS] &&
      !this.students.length > 0
    ) {
      this.getStudents()
    }
    this._setupLevels()
  },
  methods: {
    downloadStudents() {
      const params = {
        search: this.filters.search === '' ? undefined : this.filters.search,
        extraIds: this.selected.map((e) => e.idStudentExtra),
        levelIds: this.filters.levelIds,
        gradeGroupIds: this.filters.gradeGroupIds,
        orderBy: this.pagination.sortBy,
        orderType: this.pagination.descending ? 'DESC' : 'ASC',
      }

      this.working.wUpdate = true
      this.$store
        .dispatch('student/getXlsxStudentsExtra', params)
        .then((response) => {
          _genericDownloadFile({
            documentName: 'reporte-extra.xlsx',
            blob: response.data,
          })
          this.working.wUpdate = false
        })
        .catch((error) => {
          this.working.wUpdate = false
          this.toast.failed = true
          this.toast.text = 'Error al descargar alumnos'
          console.log(error)
        })
    },
    onCancel() {
      this.QRSizeModal.value = false
    },
    async desitionSize(e) {
      this.QRSizeModal.value = false
      const smallQr = 120
      const pageBreak = e.space === false
      this._downloadPdfQr(e.size === smallQr, pageBreak)
    },
    archivoName(e) {
      this._downloadQrImgs(e.std)
    },
    showQrSizeModalAll() {
      this.allQrs = true
      this.QRSizeModal.title = 'Descarga de QR'
      this.QRSizeModal.value = true
    },
    _downloadQrImgs(fileNameInclude) {
      /**
       * Include values on file name
       */
      const fileName = Object.fromEntries(
        ['personId', 'firstName', 'lastName'].map((fileKey) => [
          fileKey,
          fileNameInclude.includes(fileKey),
        ])
      )

      const params = {
        levelIds: this.filters.levelIds,
        gradeGroupIds: this.filters.gradeGroupIds,
        genders: undefined,
        search: this.filters.search === '' ? undefined : this.filters.search,
        extraIds: isEmpty(this.selected.length)
          ? undefined
          : this.selected.map((e) => e.idStudentExtra),
        parentCount: undefined,
        ...fileName,
      }

      this.working.wUpdate = true
      this.$store
        .dispatch('student/getQrImgExtraStudent', params)
        .then((response) => {
          _downloadFileFromContentDisposition({ response })
          this.toast.success = true
          this.QRSizeModal.value = false
        })
        .catch((error) => {
          this.toast.failed = true
          this.toast.text = 'Error al descargar archivo'
          console.log(error)
        })
        .finally(() => {
          this.working.wUpdate = false
          this.QRSizeModal.value = false
        })
    },
    _downloadPdfQr(isSmall = true, pageBreak = true) {
      const params = {
        levelIds: this.filters.levelIds,
        gradeGroupIds: this.filters.gradeGroupIds,
        genders: undefined,
        search: this.filters.search === '' ? undefined : this.filters.search,
        extraIds: isEmpty(this.selected.length)
          ? undefined
          : this.selected.map((e) => e.idStudentExtra),
        parentCount: undefined,
        personId: undefined,
        firstName: undefined,
        lastName: undefined,
        isSmall: isSmall,
        pageBreak: pageBreak,
      }

      this.working.wUpdate = true
      this.$store
        .dispatch('student/getExtraStudentQrPdf', params)
        .then((response) => {
          _downloadFileFromContentDisposition({ response })
          this.toast.success = true
        })
        .catch((error) => {
          this.toast.failed = true
          this.toast.text = 'Error al descargar pdf'
          console.log(error)
        })
        .finally(() => {
          this.working.wUpdate = false
          this.QRSizeModal.value = false
        })
    },
    async _setupLevels() {
      const { data } = await this.$store.dispatch(
        'student/getLevelsGradegroups'
      )

      const levels = parseLevels({ levels: data })
      const groups = parseGroups({ gradeGroups: data })
      this.headers[3].filterItems = levels
      this.headers[4].filterItems = groups
      this.posibleFilters.levels = levels
      this.posibleFilters.gradeGroups = groups
    },
    toggleAll() {
      if (this.selected.length) this.selected = []
      else this.selected = this.$refs.table.filteredItems.slice()
    },
    resetTable() {
      // this.filters.size = 25
      // this.filters.offset = 0
      // this.filters.orderBy = 'NAME'
      // this.filters.orderType = 'DEC'
      this.getStudents()
    },
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending
      } else {
        this.pagination.sortBy = column
        this.pagination.descending = false
      }
      this.getStudents()
    },
    filterSearch(val) {
      if (!this.loading) {
        this.loading = true
        this.getStudents()
      }
    },
    async filterGgs(val) {
      if (!this.loading) {
        this.loading = true
        if (this.filters.gradeGroupIds.length === 0 && val === true) {
          this.headers[3].filterItems = this.posibleFilters.levels
          await this.getStudents()
          return
        }

        const levels = filterByGroup({
          groupsIds: this.filters.gradeGroupIds,
          posibleGroups: this.posibleFilters.gradeGroups,
          posibleLevels: this.posibleFilters.levels,
        })

        this.headers[3].filterItems = levels
        await this.getStudents()

        if (
          isEmpty(this.students) &&
          isNotEmpty(this.filters.gradeGroupIds) &&
          isNotEmpty(this.filters.levelIds)
        ) {
          this.headers[3].filterItems = this.posibleFilters.levels
          this.headers[4].filterItems = this.posibleFilters.gradeGroups
          await this.getStudents()
        }
      }
    },
    async filterLevel(val) {
      if (!this.loading) {
        this.loading = true
        if (this.filters.levelIds.length === 0 && val === true) {
          this.headers[4].filterItems = this.posibleFilters.gradeGroups
          await this.getStudents()
          return
        }

        const groups = filterByLevel({
          levelIds: this.filters.levelIds,
          posibleGroups: this.posibleFilters.gradeGroups,
        })
        this.headers[4].filterItems = groups
        await this.getStudents()

        if (
          isEmpty(this.students) &&
          isNotEmpty(this.filters.gradeGroupIds) &&
          isNotEmpty(this.filters.levelIds)
        ) {
          this.headers[3].filterItems = this.posibleFilters.levels
          this.headers[4].filterItems = this.posibleFilters.gradeGroups
          await this.getStudents()
        }
      }
    },
    unlinkConfirm() {
      if (this.selected.length == 1) {
        this.confirm.description =
          'Estás a punto de desvincular a ' +
          this.selected[0].firstName +
          ' ' +
          this.selected[0].lastName +
          ', además si cuenta con encuestas, estas ya no le serán enviadas al tutor, ¿Deseas continuar con la desvinculación?'
      } else {
        this.confirm.description =
          'Estás a punto de desvincular a ' +
          this.selected.length +
          ' alumnos, además si cuentan con encuestas, estas ya no le serán enviadas al tutor, ¿Deseas continuar con la desvinculación?'
      }

      this.confirm.value = true
      this.confirm.title = 'Confirmación'
      this.confirm.show = true
    },
    mapPermits() {
      this.userPermissions = _getUserPermissions({
        getUser: this.getUser,
        possibleUserModulePermissions: this.possibleUserModulePermissions,
      })
    },
    async getStudents(isInitialStateParams = false) {
      const params = {
        ...this.filters,
        ...this.pagination,
        orderBy: this.pagination.sortBy,
        orderType: this.pagination.descending ? 'DESC' : 'ASC',
        offset: (this.pagination.page - 1) * this.pagination.rowsPerPage,
        size: this.pagination.rowsPerPage,
        totalItems: 0,
      }

      if (isInitialStateParams === true) {
        const tempObj = structuredClone(params)
        const tempParams = Object.keys(tempObj)
          .filter((e) => tempObj[e] !== undefined)
          .map((e) => `${e}_${tempObj[e]}`)
        this.initialStateParams = tempParams
        return
      }

      const tempObj = structuredClone(params)
      const tempParams = Object.keys(params)
        .filter((e) => tempObj[e] !== undefined)
        .map((e) => `${e}_${tempObj[e]}`)

      this.showFilter = _isSomeDifferent(
        structuredClone(this.initialStateParams),
        tempParams
      )

      this.loading = true
      try {
        const result = await this.$store.dispatch(
          'student/getStudentsForExtraLevels',
          params
        )
        const mutatedResultData = result.data.data
        this.students = mutatedResultData
        this.totalItemsFromBackend = result.data.total
        this.loading = false
      } catch (error) {
        this.toast.failed = true
        this.loading = false
        console.log(error)
      }

      // --------------
      // await this.$store
      //   .dispatch('student/getStudentsForExtraLevels', this.filters)
      //   .then((response) => {
      //     response.data.entity.forEach(
      //       (s) => (s.idStudentExtra = '' + s.id + s.gg.id)
      //     )
      //     this.students = response.data.entity
      //     this.totalItemsFromBackend = response.data.size
      //     this.loading = false
      //   })
      //   .catch((error) => {
      //     this.toast.failed = true
      //     this.loading = false
      //     console.log(error)
      //   })
    },
    selectStudent(student) {
      this.selectedA.student = student
      this.modals.linkSL = true
    },
    unLinkStudentExtra() {
      var std = []
      var arr = {}
      this.working.wUpdate = true
      for (let a = 0; a < this.selected.length; a++) {
        arr = {
          id: this.selected[a].id,
          level: {
            id: this.selected[a].level.id,
          },
          gg: {
            id: this.selected[a].gradeGroup.id,
          },
        }
        std.push(arr)
      }

      this.$store
        .dispatch('student/unlinkStudentsLevelExtra', std)
        .then((response) => {
          this.working.wUpdate = false
          this.toast.success = true
          this.toast.text = response.message
          this.confirm.value = false
          this.selected = []
          this.getStudents()
        })
        .catch((error) => {
          this.working.wUpdate = false
          this.toast.failed = true
          this.toast.text = error.message
          this.confirm.value = false
        })
    },
    clearSearch() {
      this.filters.search = ''
      this.getStudents()
    },
    removeFilters() {
      this.pagination.page = 1
      this.pagination.descending = false
      this.pagination.rowsPerPage = 25
      this.pagination.sortBy = 'NAME'
      this.selected = []
      this.filters.search = ''
      this.filters.levelIds = []
      this.filters.gradeGroupIds = []
      this.selectedA.student = {}
      this.headers[3].filterItems = this.posibleFilters.levels
      this.headers[4].filterItems = this.posibleFilters.gradeGroups
      this.getStudents()
    },
  },
  computed: {
    // filtersRemove() {
    //   return (
    //     this.filters.levelIds.length ||
    //     this.filters.search ||
    //     this.filters.gradeGroupIds.length ||
    //     this.selected.length
    //   )
    // },
    indexedItems() {
      return this.students.map((item, index) => ({
        idTable: index,
        ...item,
      }))
    },
    ...mapGetters(['getBranch', 'getUser']),
  },
}
</script>

<style scoped>
.sortable_pick {
  cursor: pointer;
}
.sort_arrow {
  display: inline-block;
  width: 10px;
  position: absolute;
  top: calc(50% - 10px);
  left: calc(90%);
}
.main-tool-bar {
  z-index: 1;
}
::v-deep .main-tool-bar .v-toolbar__content {
  height: auto !important;
}
::v-deep .table-full .v-datatable.v-table > tbody {
  max-height: calc(105vh - 426px);
  min-height: calc(105vh - 426px);
}
</style>
